import DOMPurify from 'dompurify';

/**
 * Sanitizes an HTML string using DOMPurify to prevent XSS
 * when rendering via dangerouslySetInnerHTML.
 *
 * @param {string} html - Raw HTML string to sanitize.
 * @returns {string} Sanitized HTML string, or empty string if input is falsy.
 */
const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html);
};

export default sanitizeHtml;
